import React, { Component } from "react";
import { GetUser, GetListings, TranslateListing } from "../../utils/consts";
import firebase from "../../utils/firebase";

import Button from "@atlaskit/button";
import { FieldTextStateless } from "@atlaskit/field-text";
import ProfilePreviewCard from "../../components/ProfilePreviewCard/ProfilePreviewCard";
import ListingPreviewCard from "../../components/ListingPreviewCard/ListingPreviewCard";

const SearchParams = ["uid", "lid"];

export default class AdminCreate extends Component {
  state = {
    lid: "",
    uid: ""
  };

  componentDidMount() {
    this.setSearchFromParams();
  }

  setSearchFromParams = () => {
    if (!(this.props.location && this.props.location.search)) return;
    const string = this.props.location.search || "";
    const params = new URLSearchParams(string);
    SearchParams.filter(key => !!params.get(key)).forEach(key =>
      this.setState({ [`${key}`]: params.get(key) })
    );
  };

  search = async () => {
    this.setState({
      user: null,
      uidError: false,
      listing: null,
      lidError: false,
      loading: true
    });
    const { uid, lid } = this.state;
    if (!uid) this.setState({ uidError: true });
    if (!lid) this.setState({ lidError: true });
    if (!uid || !lid) return;
    const listing = await GetListings(lid)
      .then(listings => listings[lid])
      .then(listing => TranslateListing(listing));
    const user = await GetUser(uid);
    this.setState({
      user,
      listing,
      uidError: false,
      lidError: false,
      loading: false
    });
  };

  create = () => {
    this.setState({ loading: true });

    const create = firebase.functions().httpsCallable("createSignatureDoc");
    create({ lid: this.state.lid, uid: this.state.uid })
      .then(result => {
        console.log(result);
        this.props.addFlag({
          appearance: 2,
          title: "Doc Sent"
        });
        this.setState({
          loading: false,
          lid: "",
          uid: "",
          user: null,
          uidError: false,
          listing: null,
          lidError: false
        });
      })
      .catch(error => {
        console.log(error);
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Retry"
        });
        this.setState({
          loading: false
        });
      });
  };

  onChange = e => this.setState({ [`${e.target.name}`]: e.target.value });

  // goListing = lid => <Redirect to={`/listing/${lid}`} />;
  goTo = url => this.props.history.push(url);

  render() {
    const listing = this.state.listing || {};
    const user = this.state.user || {};
    console.log(listing);
    return (
      <div style={{ width: "100%" }} className="admin-create">
        <FieldTextStateless
          required
          label="Listing ID"
          onChange={this.onChange}
          name="lid"
          id="lid"
          value={this.state.lid}
          shouldFitContainer={true}
          isInvalid={this.state.lidError}
        />
        <FieldTextStateless
          required
          label="User ID"
          onChange={this.onChange}
          name="uid"
          id="uid"
          value={this.state.uid}
          shouldFitContainer={true}
          isInvalid={this.state.uidError}
        />
        <Button
          className="admin-create__create-btn"
          isLoading={this.state.loading}
          isDisabled={!(this.state.uid && this.state.lid)}
          onClick={this.search}
          appearance={
            this.state.lid &&
            this.state.uid &&
            !this.state.user &&
            !this.state.listing
              ? "primary"
              : "default"
          }
          shouldFitContainer
        >
          Search
        </Button>
        <div className="admin-create__cards">
          <ProfilePreviewCard
            actions={[
              {
                label: "View",
                id: user.uid,
                callback: () => this.goTo(`/admin/user?uid=${user.uid}`)
              }
            ]}
            data={this.state.user}
          />
          <ListingPreviewCard
            actions={[
              {
                label: "View",
                id: listing.lid,
                callback: () => this.goTo(`/listing/${listing.lid}`)
              }
            ]}
            data={this.state.listing}
          />
        </div>
        <Button
          className="admin-create__create-btn"
          isLoading={this.state.loading}
          isDisabled={!(this.state.user && this.state.listing)}
          onClick={this.create}
          appearance="primary"
          shouldFitContainer
        >
          Create Document
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin/AdminCreate.js